import {fetchAdverts} from "../../api/api";
import {createAsyncThunk} from "@reduxjs/toolkit";
import {RequestParams} from "../../api/RequestParams";
import {RootStore} from "../rootStore";
import {SORT_BY_FIELDS} from "../../data/defaults";

export const fetchAds = createAsyncThunk(
    "searchResult/fetchResult",
    async (_: void, {rejectWithValue, fulfillWithValue, getState}) => {
        const {searchResult: state} = getState() as RootStore;

        try {
            const requestParams = new RequestParams(
                {...state.filters}
                ,
                {
                    field: state.sortField,
                    direction: SORT_BY_FIELDS.find(i => i.id == state.sortField)?.desc ? "desc" : "asc"
                },
                {
                    size: state.pageSize,
                    number: state.currentPage
                }
            );
            const res = await fetchAdverts(requestParams);
            return fulfillWithValue(res);
        } catch {
            return rejectWithValue("Error");
        }
    }
);